import { render } from "./RelationshipKanban.vue?vue&type=template&id=709b294e&scoped=true&ts=true"
import script from "./RelationshipKanban.vue?vue&type=script&lang=ts"
export * from "./RelationshipKanban.vue?vue&type=script&lang=ts"

import "./RelationshipKanban.vue?vue&type=style&index=0&id=709b294e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-709b294e"]])

export default __exports__